import styled, { css } from "styled-components/macro";
import { rgba } from "polished";

import {
  colors,
  breakpoint,
  space,
  zIndex,
  GRID_GAP_VERTICAL,
  GRID_GAP_HORIZONTAL,
  LEFT_CONTAINER_WIDTH,
  ContentWidth,
} from "shared/styles/constants";

export interface HeaderImageContainerProps {
  isCenter?: boolean;
}

export const HeaderImageContainer = styled.div<HeaderImageContainerProps>`
  position: relative;

  width: 100vw;
  height: 280px;

  margin: 0 -${space.s} -80px -${space.s}; // pull title over image

  z-index: ${zIndex.below};

  img {
    height: 100%;
    width: 100%;
    object-fit: cover;

    background-color: ${colors.grey1};
  }

  &::after {
    content: "";

    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;

    background: linear-gradient(
      360deg,
      ${colors.extraBlack} 0%,
      ${rgba(colors.extraBlack, 0)} 100%
    );
  }

  ${breakpoint("m", "up")} {
    width: calc(100vw - 224px - ${GRID_GAP_HORIZONTAL});
    margin: -${GRID_GAP_VERTICAL} 0 -${space.xl} 0;

    &::after {
      background: linear-gradient(
          360deg,
          ${colors.extraBlack} 0%,
          ${rgba(colors.extraBlack, 0)} 50%
        ),
        radial-gradient(
          86.61% 86.61% at 50% 50%,
          ${rgba(colors.extraBlack, 0)} 0%,
          ${rgba(colors.extraBlack, 0)} 40.51%,
          ${colors.extraBlack} 100%
        ),
        linear-gradient(90deg, ${colors.extraBlack} 0%, ${rgba(colors.extraBlack, 0)} 15.75%);
    }
  }

  ${breakpoint("l", "up")} {
    width: calc(100vw - ${LEFT_CONTAINER_WIDTH}px - ${GRID_GAP_HORIZONTAL});
  }

  ${({ isCenter }) =>
    isCenter &&
    css`
      ${breakpoint("m", "up")} {
        width: 100vw !important;
        margin-left: calc((100vw - ${ContentWidth.default}) / -2) !important;
      }
    `}
`;
